import { Button, Space, Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import styles from "./Table.module.scss";
import { TablePagination } from "SuperAdmin/Components";
import { LoadingTable } from "SuperAdmin/Components";
import Role from "../Role/Role";
const TableAccounts = ({
  data,
  pagination,
  setPagination,
  filters,
  setFilters,
}) => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Institution",
      dataIndex: "institution_name",
      key: "institution_name",
    },
    {
      title: "Department",
      dataIndex: "department",
      render: (_, record, index) => {
        return (
          <div key={index}>
            {record.departments.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
        );
      },
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
    },
    {
      title: "Roles",
      key: "roles",
      width: "20%",
      render: (_, record, index) => {
        return record?.roles.map((item, i) => {
          return <Role key={i} item={item} />;
        });
      },
      filters: [
        {
          text: "Institution",
          value: "1",
        },
        {
          text: "Unit",
          value: "2",
        },
        {
          text: "Personal profile",
          value: "3",
        },
      ],
      filterMultiple: false,
    },
    {
      title: "Status",
      key: "status",
      render: (_, record, index) => {
        return (
          <Tag color={record.activate ? "green" : "red"}>
            {record.activate ? "Enable" : "Disable"}
          </Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              navigate(`/super-admin/accounts/${record.id}`);
            }}
          >
            Detail
          </Button>
        </Space>
      ),
    },
  ];
  const onChange = (_, filter) => {
    setFilters({ ...filters, entity_type: filter.roles[0] });
  };
  console.log(data);
  return (
    <div>
      <LoadingTable
        columns={columns}
        rows={pagination.rowsPerPage}
        isLoading={data.isLoading}
        component={
          <Table
            rowKey={(record) => record.id}
            className="table"
            columns={columns}
            dataSource={data.data}
            pagination={{ position: ["none", "none"] }}
            onChange={onChange}
          />
        }
      />
      <TablePagination pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

export default TableAccounts;
